import { render } from "./PeopleCounterPage.vue?vue&type=template&id=388afe94"
import script from "./PeopleCounterPage.vue?vue&type=script&lang=js"
export * from "./PeopleCounterPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src413274616/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__